import { HVAC_LICENSE } from './contact';
import { REVIEW_SUMMARY } from './reviews';

const trustItems = [
  { label: 'Locally serving Salt Lake County' },
  {
    label: `${REVIEW_SUMMARY.rating} from ${REVIEW_SUMMARY.count} Google reviews`,
    href: REVIEW_SUMMARY.sourceUrl,
  },
  { label: `Utah HVAC license #${HVAC_LICENSE}` },
  { label: '24-hour emergency service available' },
];

export default trustItems;
